import { collection, query, where } from 'firebase/firestore'
import { firestore } from '../firebase'
import { Workout } from '../types/workouts'
import { useEffect, useMemo, useState } from 'react'
import { set } from 'lodash'
import useCustomFirestoreQueryData from './query/useCustomFirestoreQueryData'

export const useWorkoutSet = (workoutData: Workout.Item, queryKey: string) => {
  const setID = workoutData.set?.id
  const playbookReferenceID = workoutData.playbookReferenceID

  const setRef = query(
    collection(firestore, 'workouts'),
    where('set.id', '==', setID || 'no-id'),
    where('id', '!=', playbookReferenceID || 'no-id') // Filtering out the current workout
  )

  const [setItems, setSetItems] = useState<Workout.Item[]>(
    workoutData ? [workoutData] : []
  )

  const defaultScalingOption: Workout.ScalingOption = {
    ageGroup: 'masters',
    effort: 'rx',
    genderGroup: 'women',
  }
  const [activeScalingOption, setActiveScalingOption] =
    useState<Workout.ScalingOption>(defaultScalingOption)

  const [activeWorkout, setActiveWorkout] = useState<Workout.Item>(workoutData)

  useEffect(() => {
    setActiveWorkout(workoutData)
  }, [workoutData])

  const setItemsRaw = useCustomFirestoreQueryData({
    queryKey: ['workout-set', { queryKey, setID, playbookReferenceID }],
    query: setRef,
    subscribe: false,
    queryOptions: {
      enabled: !!setID,
    },
  })

  const currentSetItems = useMemo(
    () =>
      setItems.length > 1
        ? setItems
        : setItemsRaw.data
        ? [workoutData, ...(setItemsRaw.data as Workout.Item[])]
        : [workoutData],
    [setItems, setItemsRaw.data]
  )

  const handleScalingChange = (item: Workout.Item | undefined) => {
    if (item) setActiveWorkout(item)
  }

  return {
    setItems: currentSetItems,
    setItemsAreLoading: setItemsRaw.isLoading,
    activeWorkout,
    activeScalingOption,
    defaultScalingOption,
    temporarilyUpdateSetItems: (data: any) => {
      setSetItems(data)
    },
    onScalingChange: handleScalingChange,
  }
}
